const envDomain = "127.0.0.1:8000";

export const environment = {
  displayedDomain: "alk.dev.cyberskiller.com",
  production: false,
  apiLocation: "/api/",
  apiDomain: "",
  wsLocation: `ws://${envDomain}/ws/`,
  judge0ApiLocation: "https://judge.cyberskiller.com/",
  captchaMocked: true,
  defaultLang: "pl",
  langKey: "ALK",
  sentryDsn: "https://988d1134f46c44e08ba9c5907a19baa8@glitchtip.staging.cyberskiller.com/2",
  sentryEnvironment: "dev",
  sentryTracesSampleRate: 0.02,
};
